import { useQuery } from 'react-query';
import { queryKeys } from '../queryKeyFactory';
import { fetchRetailPDF } from '../../services/content/content.service';

interface useFetchCompanySnapshotResult {
  data?: any;
  isLoading: boolean;
  isError: boolean;
  isFetched: boolean;
  refetch: any;
  isFetching: boolean;
  remove: any;
}

const preformatEntitlements = (entitlements?: string[]) => {
  if (entitlements) {
    return [
      entitlements.map((entitlement) => {
        const parts = entitlement.split(':');

        return [`permission/${parts[2]}`];
      }),
    ];
  }
  return undefined;
};

export default (companyId: string, printedFor?: string, entitlements?: string[]): useFetchCompanySnapshotResult => {
  const { data, isLoading, isError, isFetched, refetch, isFetching, remove } = useQuery(
    [queryKeys.fetchCompanySnapshot],
    async () => {
      return fetchRetailPDF(companyId, printedFor, preformatEntitlements(entitlements));
    },
    {
      enabled: false,
    }
  );
  return { data, isLoading, isError, isFetched, refetch, isFetching, remove };
};
